import { Image, message, Space } from 'antd';
import { Locale } from 'antd/es/locale';
import { Trans } from 'react-i18next';
import AllAntdLocales from './all-locales';
import dayjs from './dayjs-locales';
import i18n from './i18n';
import './LanguageSelector.css';
import pngDe from "./resources/CountryFlags/de.png";
import pngFr from "./resources/CountryFlags/fr.png";
import pngEn from "./resources/CountryFlags/gb.png";
import pngAR from "./resources/CountryFlags/sa.png";

interface LanguageSelectorProps {
    onLanguageChange: (lang: Locale) => void;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({onLanguageChange}) => {

    const onClickLanguage = async (language: string) => {
        // loading();
        console.log(language)
        dayjs.locale(language)
        // await
        // onLanguageChange(language); // Call the callback function with the selected language
        switch (language) {
            case "en":
                onLanguageChange(AllAntdLocales.enUS);
                break;

            case "fr":
                onLanguageChange(AllAntdLocales.frFR);
                break;

            case "ar":
                onLanguageChange(AllAntdLocales.arEG);
                break;

            case "de":
                onLanguageChange(AllAntdLocales.deDE);
                break;

            default:
                onLanguageChange(AllAntdLocales.enUS);
                break;
        }
        await i18n.changeLanguage(language);

        await message.success({
            key,
            content: <Trans i18nKey={"UpdateLanguage"}/>,
            duration: 2,
        });
    };

    const key: string = 'Message';

    // const loading = () => {
    //     messageApi.open({
    //         key,
    //         type: 'loading',
    //         // content: <Trans i18nKey={"Copyright"}/>,
    //         content:"Modification en cours...",
    //     });
    // };
    return (
        <>
            <Space direction={"vertical"} size={1}>
                <div className="choice">
                    <Trans i18nKey={"LangChoice"}/>
                </div>

                <Space direction={"horizontal"}>
                    <div className={"home5Main1Img"}>
                        <Image
                            src={pngEn}
                            alt="English"
                            onClick={() => onClickLanguage('en')}
                            preview={false}
                        />
                    </div>
                    <div className={"home5Main1Img"}>
                        <Image
                            src={pngFr}
                            alt="Français"
                            onClick={() => onClickLanguage('fr')}
                            preview={false}
                        />
                    </div>
                    <div className="home5Main1Img">
                        <Image
                            src={pngAR}
                            alt="عرب"
                            onClick={() => onClickLanguage('ar')}
                            preview={false}
                        />
                    </div>
                    <div className="home5Main1Img">
                        <Image
                            src={pngDe}
                            alt="Deutsch"
                            onClick={() => onClickLanguage('de')}
                            preview={false}
                        />
                    </div>
                </Space>
            </Space>

            {/*<div className="home5Main">*/}
            {/*    <div className="home5Main1Img">*/}
            {/*        <Image*/}
            {/*            src={pngEn}*/}
            {/*            alt="English"*/}
            {/*            onClick={() => onClickLanguage('en')}*/}
            {/*            preview={false}*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*    <div className="home5Main1Img">*/}
            {/*        <Image*/}
            {/*            src={pngFr}*/}
            {/*            alt="Français"*/}
            {/*            onClick={() => onClickLanguage('fr')}*/}
            {/*            preview={false}*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*    <div className="home5Main1Img">*/}
            {/*        <Image*/}
            {/*            src={pngAR}*/}
            {/*            alt="عرب"*/}
            {/*            onClick={() => onClickLanguage('ar')}*/}
            {/*            preview={false}*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*    <div className="home5Main1Img">*/}
            {/*        <Image*/}
            {/*            src={pngDe}*/}
            {/*            alt="Deutsch"*/}
            {/*            onClick={() => onClickLanguage('de')}*/}
            {/*            preview={false}*/}
            {/*        />*/}
            {/*    </div>*/}
            {/*    <div className="choice">*/}
            {/*        <Trans i18nKey={"LangChoice"}/>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </>
    );
};

export default LanguageSelector;
